import * as Sentry from '@sentry/browser';
import { RewriteFrames } from '@sentry/integrations';
import { SENTRY_DSN } from 'app/common/constants';

let sentryOptions = {};

if (SENTRY_ENVIRONMENT == 'production' || SENTRY_ENVIRONMENT == 'staging') {
    sentryOptions = {
        dsn: SENTRY_DSN,
        environment: SENTRY_ENVIRONMENT,
        release: SENTRY_RELEASE,
        integrations: [new RewriteFrames()],
        ignoreErrors: [
            'This browser does not support audio output selection',
            'Unable to find node on an unmounted component',
            'Network Error',
            'failed to send, dropping',
        ],
    };
}

Sentry.init(sentryOptions);
Sentry.setTag('beta', !!BETA);
